<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-button @click="libros()">&lt;&nbsp;ir a libros</ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" >
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Tab 2</ion-title>
        </ion-toolbar>
      </ion-header>
        <p class="ion-padding">Introduzca al menos DNI (con letra)+teléfono del padre o madre del alumno para poder consultar más tarde las reservas</p>
        <div v-if="contact.code" style="text-align:center">
            Código de reserva:
            <div v-if="contact._id!=''" style="font-size:.8rem" >
            Modificada: {{fecha}} </div>
            <h2 style="color:red">{{contact.code}}</h2>
        </div>

        <ion-item>
            <ion-label position="stacked">Nombre y dos apellidos del alumno</ion-label>
            <ion-input required type="text" v-model="contact.name"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Nombre y dos apellidos de la madre</ion-label>
            <ion-input type="text" v-model="contact.mothername"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Teléfono de la madre</ion-label>
            <ion-input type="text" v-model="contact.motherphone"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">DNI de la madre</ion-label>
            <ion-input type="text" v-model="contact.motherdni"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Nombre y dos apellidos del padre</ion-label>
            <ion-input type="text" v-model="contact.fathername"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Teléfono del padre</ion-label>
            <ion-input type="text" v-model="contact.fatherphone"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">DNI del padre</ion-label>
            <ion-input type="text" v-model="contact.fatherdni"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="stacked">Email de contacto</ion-label>
            <ion-input type="text" v-model="contact.email"></ion-input>
        </ion-item>

        <ion-card>
        <ion-card-content>

        <h1>Libros seleccionados: <b style="color:red">{{booksCount}}</b></h1>
        <h1>Precio total: <b style="color:red">{{booksPrice}} €</b></h1>
        <h1 v-if="bancoLibros">
            Si perteneces al banco de libros se descuentan 160€. El precio al hacer la transferencia será de <b style="color:red">{{booksPrice-160}} €</b>
        </h1>
        </ion-card-content >
        <ion-list>
            <ion-item v-for="book in booksSelected" :key="book.id">{{book.name}} - {{book.ISBN}}</ion-item>
        </ion-list>
        </ion-card>

        <p></p>
        <br/>
        <div style="text-align:center">

        <h4>Protección de datos</h4>
            <ion-label>Debe confirmar haber leído y comprendido las condiciones de tratamiento de datos y aceptarlas en el siguiente campo</ion-label>
      <p style="font-size:0.8rem;padding:1rem;text-align:justify">Sus datos personales forman parte del fichero de la Asociación de Madres y Padres de Alumnos del Colegio Sagrado Corazón de Meliana, con la finalidad de realizar los servicios y las actividades acordadas por la asamblea general e informarle del funcionamiento de la AMPA. De conformidad con lo que dispone la normativa de protección de datos personales, el Reglamento (UE) 2016/679 de 27 de abril de 2016 (RGPD) y la Ley Orgánica 3/2018, e 5 de diciembre, de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD), puede ejercer los derechos de acceso, rectificación, portabilidad y supresión de los datos y los de limitación y oposición a su tratamiento dirigiéndose por escrito a la sede asociativa sita en la Calle Eduardo Romero, 6 de Meliana (Valencia), C.P. 46133, o mediante correo electrónico a ampasagradocorazonmeliana@gmail.com.     </p>

            <ion-item>
               <ion-label>Acepto las condiciones</ion-label>
               <ion-checkbox v-model="contact.aceptado"></ion-checkbox>
            </ion-item>

        <p></p>
        <h4>Tratamiento de imágenes</h4>
        <p style="font-size:.8rem;padding:1rem;text-align:justify">De conformidad con el Artículo 18 de la Constitución, la Ley 1/1982, de 5 de mayo, sobre el derecho al honor, a la intimidad personal y familiar ya la propia imagen, y a la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y Garantía de Derechos Digitales AUTORIZO a la AMPA del Colegio Sagrado Corazón de Meliana a publicar las imágenes realizadas a mi persona o a los miembros de mi familia que participen en las actividades y los servicios organizados por la Asociación con destino exclusivo a medios y publicaciones de la misma, como pueden ser, en su caso, la página web, el blog de noticias, revistas, Facebook., etc.</p>

            <ion-label>¿Acepta el uso de imágenes por parte del AMPA?</ion-label>
            <ion-radio-group v-model="contact.imagen">

                <ion-item>
                    <ion-label>SÍ AUTORIZO</ion-label>
                    <ion-radio value="SI"></ion-radio>
                </ion-item>

                <ion-item>
                    <ion-label>NO</ion-label>
                    <ion-radio value="NO"></ion-radio>
                </ion-item>
            </ion-radio-group>
        <p></p>
        <!-- PUBLICAR: descomentar para publicar -->
        
        <!--
        <ion-button color="danger" @click="send" :disabled="!canSend">Confirmar reserva</ion-button>
        -->
        <!-- fin de bloque -->
        </div>


    </ion-content>
    <ion-loading :is-open="isOpenRef" message="Espere..." @didDismiss="setOpen(false)" > </ion-loading>
  </ion-page>
</template>

<script lang="ts">
import {IonCard, IonCardContent, IonLabel, IonInput, IonList, IonItem, IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
IonRadioGroup, IonRadio, IonCheckbox,
IonLoading, IonButton } from '@ionic/vue';

import ExploreContainer from '@/components/ExploreContainer.vue';
import bookservice from '@/bookservice';
import { ref } from '@vue/reactivity';
import Book from '@/model/Book';
import Contact from '@/model/Contact';
import { computed } from '@vue/runtime-core';
import router from '../router/index';
import Config from '@/assets/Config';


export default  {
  name: 'Tab2',
  components: {  IonLabel, IonInput, IonList, IonItem, IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButton,
  IonCard, IonCardContent,
  IonRadioGroup,IonRadio,IonCheckbox,
  IonLoading  },


  setup(context: any, props: any){
        console.log(props)
        const {books} = bookservice();
        const booksSelected = computed(()=>books.value.filter(b=>b.selected));
        const booksCount = computed(()=>books.value.filter(b=>b.selected).length);
        //const booksPrice = computed(()=>books.value.reduce((total, b)=>total+(b.selected?1:0)*b.price, 0));
        const booksPrice = computed(()=>books.value.reduce((total, b)=>{
            return total+(b.selected?1:0)*b.price;
        },0));
        //const contact = ref<Contact>(Contact.contact);
        const contact = Contact.contact;
        const mothername = ref<string>('xx')

        const bancoLibros = computed(()=>{
            const found: any  = books.value.filter(b=>b.selected);
            return found.length && (found[0].course.id == '1Pri' || found[0].course.id == '2Pri');
        })

        const canSend = computed(()=>{
            console.log(contact.value)
            const c=contact.value;
            if (c.name.length<5) return false;
            if (!c.aceptado) return false;
            if (
                !((c.fatherphone && c.fatherdni) || (c.motherphone && c.motherdni))

            ) return false;
            if (!(c.imagen=='SI' || c.imagen=='NO')) return false;
            return true;

        })

        const isOpenRef = ref(false);
        const setOpen = (state: boolean) => {
            try{

            isOpenRef.value = state;
            }catch(e){
                console.error(e)
            }
        }

        const condiciones = ()=>{
            router.push('/condiciones');
        }

        const send = ()=>{
            setOpen(true);
            const controller = new AbortController();
            const signal = controller.signal;
            console.log(booksSelected)
            const booking: any = {
                ...Contact.contact.value,
                books: books.value.filter(b=>b.selected).map(b=>{
                    return {
                        ...b,
                        course: b.course.id
                    }

                }),
                date: JSON.stringify(new Date)
            };
            setTimeout(()=>{
                controller.abort();
                setOpen(false)
            }, 40000)
            fetch(Config.URL+'/save2',{
                method: 'POST',
                signal,
                headers: {
                    "Content-Type" : "application/json"
                },
                mode: 'cors',
                body: JSON.stringify(booking)

            }).then(r=>r.json())
            .then(d=>{
                console.log("guardado?", d)
                if (d && d._id){
                    contact.value._id=d._id;
                    contact.value.code=d.code;
                router.replace('/ok');
                }else{
                    router.push('/error')
                }
            })
        }

        const libros = ()=> router.replace('/tabs/tab1');

        const fecha=computed(()=>(contact.value.date.replaceAll(/[TZ]/g,' ')))

        return { books, booksSelected, booksCount, booksPrice, contact,  mothername, send, canSend, isOpenRef, condiciones, setOpen, fecha, libros, bancoLibros }
  }
}
</script>